import React, { useEffect, useRef } from 'react';
import Tool, { type ToolArgsWithController } from '../../../tools/Tool';
import { isMediaElement } from '../../../types/guards';
import styles from '../../../components/Toolbar/Toolbar.module.css';
import ToolBorderWidth from './ToolBorderWidth';

class ToolBorderWidthSlider extends Tool {
  static toolName = 'Border width slider';

  static renderToolbarComponent(toolArgs: ToolArgsWithController) {
    const { editor, controller, element } = toolArgs;

    if (!element || !isMediaElement(element)) return null;

    const currentWidth = element.media_borderWidth ?? 0;

    const sliderRef = useRef<HTMLElement>(null);

    useEffect(() => {
      const slider = sliderRef.current;
      if (slider) {
        const handleInputChange = (e: CustomEvent) => {
          ToolBorderWidth.action({
            editor,
            controller,
            element,
            width: e.detail,
          });
        };
        slider.addEventListener('aha-slider:clicked', handleInputChange);
        return () => {
          slider.removeEventListener('aha-slider:clicked', handleInputChange);
        };
      }
    }, [controller, editor, element]);

    return (
      <div className={styles.lineWidthSliderWrapper}>
        <aha-slider
          ref={sliderRef}
          step={1}
          min={0}
          max={7}
          start-value={currentWidth}
        />
      </div>
    );
  }
}

export default ToolBorderWidthSlider;
